import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import placementTestReportFilterService from './PlacementTestReportFilterService';

class PlacementTestReportStudentsListService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      data: [],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
      },
      sort: {
        field: 'startedAt',
        order: 'descend',
        columnKey: 'startedAt',
      },
    });
  }

  load = action((pagination, _, sort) => {
    if (pagination) {
      this.pagination.current = pagination.current;
    } else {
      this.pagination.current = 1;
    }
    if (sort) {
      this.sort = sort;
    }

    this.fetch
      .fetch({
        url: '/placement-test-report/students',
        query: {
          ...placementTestReportFilterService.form.getValues(),
          ...(placementTestReportFilterService.form.getValue('periodStart') &&
            placementTestReportFilterService.form.getValue('periodEnd') && {
              periodStart: placementTestReportFilterService.form.getValue('periodStart').format('YYYY-MM-DD'),
              periodEnd: placementTestReportFilterService.form.getValue('periodEnd').format('YYYY-MM-DD'),
            }),
          page: this.pagination.current,
          size: this.pagination.pageSize,
          sort: this.sort,
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.data = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.data = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });
}

const placementTestReportStudentsListService = new PlacementTestReportStudentsListService();
export default placementTestReportStudentsListService;
